var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPngIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C0.895431 0 0 0.895431 0 2V18C0 19.1046 0.89543 20 2 20H13C14.1046 20 15 19.1046 15 18V5H10V0H2Z",
    fill: "#7A5AF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5L10 0V5H15Z",
    fill: "#D6BBFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.56364 12.4508C3.9523 12.4508 4.27864 12.5773 4.54264 12.8303C4.80664 13.0833 4.93864 13.4059 4.93864 13.7983C4.93864 14.1906 4.80664 14.5133 4.54264 14.7663C4.27864 15.0193 3.9523 15.1458 3.56364 15.1458H3.05214V16.3008H2.06764V12.4508H3.56364ZM3.56364 14.2108C3.67364 14.2108 3.7653 14.1723 3.83864 14.0953C3.91564 14.0183 3.95414 13.9193 3.95414 13.7983C3.95414 13.6773 3.91564 13.5801 3.83864 13.5068C3.7653 13.4298 3.67364 13.3913 3.56364 13.3913H3.05214V14.2108H3.56364ZM7.44552 12.4508H8.42452V16.3008H7.66552L6.30702 14.3648V16.3008H5.32252V12.4508H6.08702L7.44552 14.3868V12.4508ZM12.8564 14.0953V14.4858C12.8564 15.0504 12.6786 15.5088 12.3229 15.8608C11.9709 16.2091 11.5126 16.3833 10.9479 16.3833C10.3466 16.3833 9.85161 16.1908 9.46295 15.8058C9.07795 15.4208 8.88545 14.9459 8.88545 14.3813C8.88545 13.8166 9.07795 13.3399 9.46295 12.9513C9.84795 12.5626 10.3246 12.3683 10.8929 12.3683C11.2523 12.3683 11.5804 12.4489 11.8774 12.6103C12.1781 12.7716 12.4128 12.9861 12.5814 13.2538L11.7454 13.7323C11.6684 13.6113 11.5548 13.5141 11.4044 13.4408C11.2578 13.3674 11.0909 13.3308 10.9039 13.3308C10.5996 13.3308 10.3503 13.4298 10.1559 13.6278C9.96161 13.8258 9.86445 14.0788 9.86445 14.3868C9.86445 14.6838 9.95978 14.9349 10.1504 15.1403C10.3448 15.3456 10.6161 15.4483 10.9644 15.4483C11.4118 15.4483 11.7069 15.2796 11.8499 14.9423H10.9149V14.0953H12.8564Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPngIcon);
export default __webpack_public_path__ + "static/media/pngIcon.3d61cf10b156e56e250bf795c611464c.svg";
export { ForwardRef as ReactComponent };